import Evidence from '../evidence';

/**
 * Create the action
 */

const { thunk, request, success, error } = Evidence.store((data, fetch) => {
  // Prepare request
  const formData = new FormData();

  ['processId', 'processType', 'file'].map((key) =>
    data[key] !== undefined ? formData.append(key, data[key]) : null
  );

  if (data.metadata) {
    formData.append('metadata', JSON.stringify(data.metadata));
  }

  if (data.storeForPortfolio == true) {
    return fetch.post('/portfolio-evidence', formData);
  }

  return fetch.post(`/upload-evidence`, formData);
});

/**
 * Export the components
 */

export { thunk as default };
export { request, success, error };
